import React, { FC } from 'react'
import { Callback } from 'Types/utilTypes'
import { i18n, IconComponent, UISizes, UITypes, Heading, Indent } from 'LibNeo'
import { ModalTitleWrapper } from './styled'

interface ComponentProps {
	backButtonAction?: Callback
	titleIcon?: JSX.Element
	title?: string
}

export const ModalTitleComponent: FC<ComponentProps> = ({ backButtonAction, titleIcon, title }) => {
	return (
		<Indent bottom={(backButtonAction || titleIcon || title) && 24}>
			<ModalTitleWrapper>
				<div>
					{backButtonAction && (
						<Indent right={8}>
							<IconComponent
								type={UITypes.BLACK}
								size={UISizes.BIG}
								onClick={backButtonAction}
								name="arrow-back"
							/>
						</Indent>
					)}
				</div>
				<div>
					{title && (
						<Indent right={8}>
							<Heading type="h5">{i18n(title)}</Heading>
						</Indent>
					)}
				</div>
				<div>{titleIcon}</div>
			</ModalTitleWrapper>
		</Indent>
	)
}
